export function Hero() {
  return (
    <section className="hero">
      <div className="container">
        <img src="/assets/accents/accent-sparkle.png" className="float-accent fa-1" alt="" />
        <img src="/assets/accents/accent-cube.png" className="float-accent fa-2" alt="" />
        <img src="/assets/accents/accent-code-bubble.png" className="float-accent fa-3" alt="" />
        <div className="hero-grid">
          <div>
            <div className="eyebrow">
              <span className="eyebrow-dot"></span> Eerste edities — inschrijvingen open
            </div>
            <h1>
              Technologie leren op een <span className="accent">toffe manier</span>
            </h1>
            <p className="lead">
              Zaterdagworkshops Arduino en programmeren voor kinderen 10-12 jaar. Eerste
              project: bouw je eigen <strong>Simon Says memory-game</strong> in 3 uur —
              werkend apparaat mee naar huis.
            </p>
            <div className="hero-ctas">
              <a href="#kids" className="btn btn-primary btn-lg">
                Voor kinderen 10-12 →
              </a>
              <a href="#werkplaats" className="btn btn-ghost btn-lg">
                Community (18+) →
              </a>
            </div>
            <div className="hero-stats">
              <div className="stat">
                <strong>
                  <s style={{ opacity: 0.5, fontWeight: 500, fontSize: "0.62em", marginRight: 6 }}>€50</s>
                  €30
                </strong>
                <span>Pilot-prijs · all-in, alle componenten inbegrepen</span>
              </div>
              <div className="stat">
                <strong>3u</strong>
                <span>Per zaterdag</span>
              </div>
              <div className="stat">
                <strong>Max 8</strong>
                <span>Deelnemers per groep</span>
              </div>
            </div>
          </div>
          <div className="hero-art">
            <img
              src="/assets/heroes/hero-paper-cut-nobg-v2.png"
              alt="Arduino, breadboard en 3D printer"
              className="hero-img"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
